import React, { useState } from "react";
import axios from 'axios';

import FaqTypeName from "./FaqTypeName";

//FAQ 분류 관리
const FaqTypes = ({varShowFaqTypes,varFaqTypeList,setFaqTypeList,setShowFaqTypes}) => {

  const [varCurrentFaqTypeIndex,setCurrentFaqTypeIndex] = useState(0);
  const [varCurrentFaqTypeName,setCurrentFaqTypeName] = useState('');
  const [varInputFaqTypeName,setInputFaqTypeName] = useState(false);

  //FAQ 분류 정보 삭제
  const onDeleteFaqTypeHandler = async(e,vf_idx) => {
    const sendData = {vf_idx:vf_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_delete_faq_types`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const newList = varFaqTypeList.filter(el=>el.vf_idx !== vf_idx);
        setFaqTypeList(newList);
      }
    });
  }
  //추가하기
  const onAddFaqTypeHandler = async(e) => {
    setCurrentFaqTypeIndex(0);
    setCurrentFaqTypeName('');
    setInputFaqTypeName(true);
  }
  //수정
  const onEditFaqTypeHandler = (e,vf_idx) => {
    setCurrentFaqTypeIndex(vf_idx);
    const faqInfo = varFaqTypeList.find(el=>el.vf_idx===vf_idx);
    setCurrentFaqTypeName(faqInfo.vf_name);
    setInputFaqTypeName(true);
  }
  //저장
  const onUpdateFaqTypeHandler = async(e) => {
    const sendData = {vf_idx:varCurrentFaqTypeIndex,vf_name:varCurrentFaqTypeName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_update_faq_types`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(varCurrentFaqTypeIndex === 0) {
          const vf_idx = datas.vf_idx;
          const newData = {vf_idx:vf_idx,vf_name:varCurrentFaqTypeName};
          setFaqTypeList(varFaqTypeList.concat(newData));
        } else {
          const newData = {vf_idx:varCurrentFaqTypeIndex,vf_name:varCurrentFaqTypeName};
          const copyList = [...varFaqTypeList];
          const findIndex = copyList.findIndex(el=>el.vf_idx === varCurrentFaqTypeIndex);
          copyList[findIndex] = newData;
          setFaqTypeList(copyList);
        }
      }
    });
  }

  return varFaqTypeList.length === 0?null:(
    <div className={varShowFaqTypes?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"500px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>FAQ 분류 관리</div>
          <div className="layer__pop__close" onClick={()=>setShowFaqTypes(false)}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px"}}> 
          <div style={{height:"500px"}}>
            <div style={{width:"100%",textAlign:"right",marginBottom:"5px"}}>
              <button className="btn line"  onClick={e=>onAddFaqTypeHandler(e)}>추가등록</button>
            </div>
            <table width="500" height="470" style={{border:"1px solid rgb(221, 221, 221)",display:"block",overflowY:"scroll"}}>
              <colgroup><col width="70%"/><col width="40%"/></colgroup>
              <thead style={{width:"100%",display:"inline-table"}}>
                <tr style={{width:"100%",backgroundColor:"#ddd"}}>
                  <th style={{height:"30px",textAlign:"center",padding:"0px"}}>FAQ 분류명</th>
                  <th style={{height:"30px",textAlign:"center",padding:"0px"}}>관리</th>
                </tr>
              </thead>
              <tbody style={{minWidth:"100%",maxHeight:"440px",display:"inline-table"}}>
                {varFaqTypeList?.length===0?
                  <tr><td colSpan={2} style={{textAlign:"center"}}>등록된 분류명이 없습니다.</td></tr>
                :varFaqTypeList.map((types,i)=>(
                  <tr key={'types_'+i} className="pop-table-body" style={{height:"40px",padding:"15px 0px"}}>
                    <td style={{width:"70%",paddingLeft:"30px"}}>{types.vf_name}</td>
                    <td style={{width:"40%",display:"flex",flexDirection:"row",margin:"5px 0px"}}>
                      <button className="btn line black" onClick={e=>onEditFaqTypeHandler(e,types.vf_idx)}>수정</button>
                      <button className="btn line black" onClick={e=>onDeleteFaqTypeHandler(e,types.vf_idx)}>삭제</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="btn-center" style={{display:"flex",justifyContent:"center"}}>
          <button onClick={()=>setShowFaqTypes(false)} style={{width:"90px"}} className="btn line black">닫기</button>
        </div>
      </div>
      <FaqTypeName varInputFaqTypeName={varInputFaqTypeName} setInputFaqTypeName={setInputFaqTypeName} varCurrentFaqTypeIndex={varCurrentFaqTypeIndex} 
        varCurrentFaqTypeName={varCurrentFaqTypeName} setCurrentFaqTypeName={setCurrentFaqTypeName} onUpdateFaqTypeHandler={onUpdateFaqTypeHandler}/>
    </div> 
  )
}
export default FaqTypes;